const ADMIN = '/admin'
const AUTH = '/auth'
const ORGANIZATION = '/organization'

export const AppRoutes = {
  Admin: {
    Organizations: `${ADMIN}/organizations`,
    Users: `${ADMIN}/users`,
  },
  Auth: {
    Login: `${AUTH}/login`,
    SignUp: `${AUTH}/sign-up`,
    ResetPassword: `${AUTH}/reset-password`,
  },
  Organization: {
    Invitations: `${ORGANIZATION}/invitations`,
    Create: `${ORGANIZATION}/create`,
  },
  Process: {
    organizationInvitation: (organizationId: string, token: string) =>
      `/process/organization-invitation/${organizationId}/${token}`,
  },
  SelectOrganization: '/',
  Suspended: '/suspended',
}

export const OrganizationRoutes = {
  Base: '/',
  Suspended: '/suspended',
}
